// @ts-nocheck
import { gql, useLazyQuery, useMutation } from "@apollo/client";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { RiErrorWarningFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { GetTodaysDateINdmy } from "../../../../CommonFunction/GetTodaysDate";
import { IsoToDateWithoutTime, convertToISO } from "../../../../CommonFunction/IsoDateTime";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import {
  CREATE_CONSIGNMENT_NOTE,
  CREATE_ERP_ADDRESS_BOOK_MASTER,
  CreateCustomerAccount,
  Delete_LR,
  EditLoadReceipt,
  GetAccountDataByIDForLMS,
  GetAccountDetailByMatchingAddress,
  GetEwbDetailsByewbNo,
  getFormSectionsAndFields,
  GetLoadReceiptById,
  GetLoadReceiptByIdForCopy,
  GrtPreferenceByFormKey,
  LockLoadReceipt,
  Search_Price_List,
  UserDataById,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import DocumentuploadSection from "../../../Templets/DocumentuploadSection/DocumentuploadSection";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import useConcatenatedString from "../../../custom_hooks/useConcatenatedString";
import { ErrorToast, SuccessToast } from "../../ToastComponent/RectHotToast";
import LRPickupUpdationFreightChargesForm from "../LRPickupUpdation/LRPickupUpdationSections/LRPickupUpdationFreightChargesForm";
import {
  DocUpload,
  FreightCharges,
  Loadfilds,
  AddMeterialItems,
  AddMaterial,
  AddMeterialDocsUpload,
  ConsignmentNoteConfiguration,
} from "./AddConsignmentNoteConfig";
import "./AddConsignmentNote.scss";
import { useModalContext } from "../../Reactportal/ModalContext";
import MainUserDetails from "./ReusableComponent/MainUserDetails";
import AddMeterialTable from "./AddMeterials/AddMeterialTable";
import Button from "../../Button/Button";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import {
  ClearFields,
  handleFormReset,
  updateSingleField,
  updateValueForm,
} from "../../FormInputSectionComponent/formUtils";
import AddMaterialEwayBill from "./AddMaterialEwayBill/AddMaterialEwayBill";
import InvoiceFormat from "../../../Pages/InvoiceFormat/InvoiceFormat";
import Spinner from "../../Spinner/Spinner";
import { IoSettingsOutline } from "react-icons/io5";
import { FormConfiguration } from "../../FormConfiguration/FormConfiguration";
import { useRecoilState } from "recoil";
import { AtomFormState } from "../../../../atoms/FormAtom";
import useIsDisabled from "../../../custom_hooks/useIsDisabled";
import { Confirm } from "../../Confirmation/Confirm";

axios.defaults.withCredentials = true;



const AddConsignmentNote = ({ fielddata, show, TypeOfPortal, submitType, ParentPortalCloseFunction, openByCard, openByCardId }) => {
  const modifiedTypeOfPortal = useConcatenatedString(TypeOfPortal, " Consignment Note (LR)");
  const Form_Key = "Consignment_Note";

  const [LoadFieldsstate, setLoadFields] = useState<any>(Loadfilds);
  const [toggle, settoggle] = useState(show ? show : false);
  const [notesdata, setNotesdata] = useState("");
  const [FormData, setFormdata] = useState<any>({});
  const [myData, setMyData] = useState<any>({ material: [] });
  const [invoiceData, setInvoiceData] = useState([]);
  const [itemsData, setItemsData] = useState([]);
  const [modifiedItemData, setModifiedItemData] = useState([]);
  const [totalArticle, setTotalArticle] = useState(0);
  const [totalWeight, setTotalWeight] = useState(0);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [sendValue, setSendValue] = useState(0);
  const [totalFreightAmount, setTotalFreightAmount] = useState(0);
  const { pushModal, popModal } = useModalContext();
  const [customerNotesdata, setCustomerNotesdata] = useState("");
  const [ewbNos, setEwbNos] = useState([]);
  const [tableData, setTableData] = useState<any[]>([]);
  const [Meterial, setMeterial] = useState(false);
  const [showPrintPage, setShowPrintPage] = useState(false);
  const [editIndex, setEditIndex] = useState("");
  const [currentBranch, setCurrentBranch] = useState("");
  const [ewbNo, setEwbNo] = useState(null);
  const [isFirstLoad, setFirstLoad] = useState(false);
  const [consignorAccountData, setConsignorAccountData] = useState(null);
  const [consigneeAccountData, setConsigneeAccountData] = useState(null);
  const [FovPercentage, setFovPercentage] = useState(0);
  const [GSTPercentage, setGSTPercentage] = useState(0);
  const FormDataFromRedux = useSelector((store: any) => store?.FormDataReducer);
  const fielddataRedux = useSelector((store: any) => store.UniqueTableReducer.Consignment_Note);
  const selectedRow = fielddataRedux?.Selected_Row?._id;
  let searchPriceData = FormDataFromRedux?.MasterData[Form_Key]
  const [InputFields, setInputFields] = useState([]);
  const [FreightFields, setFreightFields] = useState([]);
  const [UserDetailInputFields, setUserDetailInputFields] = useState([]);
  const [DocumentsFields, setDocumentsFields] = useState([]);
  const [FormValue, setFormValue] = useRecoilState(AtomFormState(Form_Key));
  const [openSetting, setOpenSetting] = useState(false);
  const [BranchCode, setBranchCode] = useState("");
  const [CNid, setCNid] = useState("");
  const [defaultLayout, setDefaultLayout] = useState("");
  let userData = sessionStorage.getItem("userData") && JSON.parse(sessionStorage?.getItem("userData") || "");
  const formRef = useRef({});
  const dispatch = useDispatch();
  const [allFieldsData, setAllFieldsData] = useState({});
  const [priceListData, setPriceListData] = useState({})
  const [formErrors, setFormErrors] = useState<any>({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [createLoadReceipt, { loading: CreateLoading }] = useMutation(CREATE_CONSIGNMENT_NOTE);
  const [deleteLoadReceipt, { loading: deleteLoading }] = useMutation(Delete_LR);
  const [editLoadReceipt, { loading: EditLoading }] = useMutation(EditLoadReceipt);
  const [lockLoadReceipt, { loading: LockLoading }] = useMutation(LockLoadReceipt);
  const [initialData, setInitialData] = useState({})
  const { isDisabled } = useIsDisabled({ TypeOfPortal, initial: initialData, current: FormData });

  const [getDataById, { loading: GetLoading }] = useLazyQuery(GetLoadReceiptById, {
    fetchPolicy: "no-cache",
  });
  const [getDataByIdForCopy, { loading: GetLoadingForCopy }] = useLazyQuery(GetLoadReceiptByIdForCopy, {
    fetchPolicy: "no-cache",
  });
  const [GetBillAccountDataByID, { loading: getBillAccountDataByIDLoader }] = useLazyQuery(GetAccountDataByIDForLMS, {
    fetchPolicy: "network-only",
  });

  const [searchPriceList, { loading: searchPriceListLoader }] = useLazyQuery(Search_Price_List, {
    fetchPolicy: "network-only",
  });
  const [getFormSectionAndFields, { loading: getFormSectionAndFieldsLoading }] = useLazyQuery(
    getFormSectionsAndFields,
    {
      variables: {
        key: Form_Key,
      },
      fetchPolicy: "cache-and-network",
      onCompleted: (data) => {
        // console.log(data);
        let CNFieldData = data?.formSectionAndFields.filter((e) => e.name === "Consignment_Note_Details");
        let FreightTypeField = data?.formSectionAndFields.filter((e) => e.name === "Freight_Charges");
        let DocumentsField = data?.formSectionAndFields.filter((e) => e.name === "Documents");
        let UserFieldData = data?.formSectionAndFields.filter(
          (e) => e.name !== "Consignment_Note_Details" && e.name !== "Freight_Charges" && e.name !== "Documents"
        );
        setInputFields(CNFieldData);
        setFreightFields(FreightTypeField);
        setUserDetailInputFields(UserFieldData);
        setDocumentsFields(DocumentsField)
      },
    }
  );
  const [CreatingCustomerAccount, { loading: createCustomerAccountLoading }] = useMutation(CreateCustomerAccount);

  const [getDataByKey] = useLazyQuery(GrtPreferenceByFormKey, {
    variables: {
      Form_Key: Form_Key,
    },
    fetchPolicy: "network-only",
  });
  const [getewbDetailsByNo, { loading: getewbDetailsByNoLoader }] = useLazyQuery(GetEwbDetailsByewbNo, {
    fetchPolicy: "network-only",
  });
  const [CreatingAddressBookData, { loading: createAddressBookMasterLoading }] =
    useMutation(CREATE_ERP_ADDRESS_BOOK_MASTER);
  const [getERPBookDetails, { loading: getERPBookDetailsLoader }] = useLazyQuery(GetAccountDetailByMatchingAddress, {
    fetchPolicy: "network-only",
  });
  const [getUserDataById, { loading: GetUserDataLoading }] = useLazyQuery(UserDataById, {
    fetchPolicy: "no-cache",
  });
  // GetERPAddressBookDataByGSTIN
  const LoadingState = CreateLoading || EditLoading || GetLoading;
  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  useEffect(() => {
    getFormSectionAndFields();
  }, []);

  //to check errors and throw the error submit will not
  const Validate_handleSubmit = (submit, close) => {
    const formErrorsNew = {
      0: formErrors?.Consignment_Note_Details,
      1: formErrors?.Consignor_Details,
      2: formErrors?.Consignee_Details,
      3: formErrors?.Bill_Account_Details,
    };
    const Error = checkFormErrors(formErrorsNew);
    if (!Error) {
      if (close == "close") {
        submit("close");
      } else if (close == "Print") {
        submit("Print");
      } else {
        submit("");
      }
    }
  };

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key);
    };
  }, []);

  useEffect(() => {
    if (itemsData) {
      let newItemData = itemsData?.length > 0 ? itemsData.map((e) => {
        let obj = {};
        obj.No_Of_Boxes = e?.No_Of_Boxes;
        obj.Part_Name = e?.Part_Name;
        obj.Part_Number = e?.Part_Number;
        obj.Volumetric_Weight = e?.Volumetric_Weight;
        obj.Actual_Weight = e?.Actual_Weight;
        obj.Charge_Weight = e?.Charge_Weight;
        obj.Rate = e?.Rate;
        obj.Freight_Amount = e?.Freight_Amount;
        if (e?.Part_Name_Data) {
          obj.Part_Name = e?.Part_Name_Data?.Part_Name;
        }
        return obj;
      }) : [];
      setModifiedItemData(newItemData);
    }
  }, [itemsData]);

  useEffect(() => {
    getDataByKey({
      variables: {
        Form_Key: Form_Key,
      },
    })
      .then(({ data }) => {
        let defaultData = data?.User_Preferences_By_Form_Key?.printConfigurationData;
        setDefaultLayout(defaultData?.Default_Layout?.Search_Value);
      })
      .catch((err) => {
        console.log(err);
        setDefaultLayout("");
      });
  }, []);

  useEffect(() => {
    setSelectedRows(fielddataRedux?.SelRows_ids || []);
  }, [fielddataRedux]);

  useEffect(() => {
    if (isFirstLoad && searchPriceData?.Bill_Consignor?._id && searchPriceData?.Service_Type?._id && searchPriceData?.From_City?._id && searchPriceData?.To_City?._id) {

      searchPriceList({ variables: { customerId: searchPriceData?.Bill_Consignor?._id, serviceType: searchPriceData?.Service_Type?._id, from: searchPriceData?.From_City?._id, to: searchPriceData?.To_City?._id } }).then((res) => {

        let ChargesData = { ...res?.data?.getPriceListOfCustomer }
        setPriceListData(ChargesData)
        if (ChargesData?.Price_List_Data?.Docket_Charge) {
          updateSingleField(formRef, "Docket_Amount", ChargesData?.Price_List_Data?.Docket_Charge);
        }
        if (ChargesData?.Price_List_Data?.FOV) {
          updateSingleField(formRef, "FOV", ChargesData?.Price_List_Data?.FOV);
        }
        if (ChargesData?.Price_List_Data?.FSC) {
          updateSingleField(formRef, "FSC", ChargesData?.Price_List_Data?.FSC);
        }

      }).catch((err) => ErrorToast(err?.message))
    }
  }, [searchPriceData?.Bill_Consignor?._id, searchPriceData?.Service_Type?._id, searchPriceData?.From_City?._id, searchPriceData?.To_City?._id]);

  useEffect(() => {
    if (priceListData?.Price_List_Rates_Data?.[0]?.Pickup_Charge) {
      if (priceListData?.Price_List_Rates_Data?.[0]?.Pickup_On) {
        let pickon = priceListData?.Price_List_Rates_Data?.[0]?.Pickup_On
        let pickCharge = priceListData?.Price_List_Rates_Data?.[0]?.Pickup_Charge
        if (pickon == "Weight") {
          let pickTotal = totalWeight ? totalWeight * pickCharge : pickCharge
          updateSingleField(formRef, "Pickup_Charges", pickTotal);
        } else if (pickon == "Per Article") {
          let pickTotal = totalArticle ? totalArticle * pickCharge : pickCharge
          updateSingleField(formRef, "Pickup_Charges", pickTotal);
        } else if (pickon == "Quantity") {
          let pickTotal = totalQuantity ? totalQuantity * pickCharge : pickCharge
          updateSingleField(formRef, "Pickup_Charges", pickTotal);
        } else if (pickon == "Fixed") {
          let pickTotal = pickCharge
          updateSingleField(formRef, "Pickup_Charges", pickTotal);
        }
      }
    }

    if (priceListData?.Price_List_Rates_Data?.[0]?.Delivery_Charge) {
      if (priceListData?.Price_List_Rates_Data?.[0]?.Delivery_On) {
        let deliveryon = priceListData?.Price_List_Rates_Data?.[0]?.Delivery_On
        let deliveryCharge = priceListData?.Price_List_Rates_Data?.[0]?.Delivery_Charge
        if (deliveryon == "Weight") {
          let deliveryTotal = totalWeight ? totalWeight * deliveryCharge : deliveryCharge
          console.log(deliveryTotal, totalWeight, "deliveryTotal")
          updateSingleField(formRef, "Delivery_Charges", deliveryTotal);
        } else if (deliveryon == "Per Article") {
          let deliveryTotal = totalArticle ? totalArticle * deliveryCharge : deliveryCharge
          updateSingleField(formRef, "Delivery_Charges", deliveryTotal);
        } else if (deliveryon == "Quantity") {
          let deliveryTotal = totalQuantity ? totalQuantity * deliveryCharge : deliveryCharge
          updateSingleField(formRef, "Delivery_Charges", deliveryTotal);
        } else if (deliveryon == "Fixed") {
          let deliveryTotal = deliveryCharge
          updateSingleField(formRef, "Delivery_Charges", deliveryTotal);
        }
      }
    }
  }, [totalWeight, totalArticle, totalQuantity, priceListData])

  useEffect(() => {
    if (FormDataFromRedux?.MasterData[Form_Key]?.Driver_Name) {
      updateSingleField(formRef, "Driver_Number", FormDataFromRedux?.MasterData[Form_Key]?.Driver_Name?.Mobile_Number);
    }
  }, [FormDataFromRedux?.MasterData[Form_Key]?.Driver_Name]);

  useEffect(() => {
    if (InputFields.length) {
      if (userData.userDetails[0]._id && TypeOfPortal == "Add") {
        getUserDataById({
          variables: {
            ID: userData?.userDetails[0]?._id,
          },
        }).then((res) => {
          if (res?.data?.user[0]?.LR_Center_Data?.Center_Name) {
            const inputNames = ["LR_Center"];

            inputNames.forEach((name) => {
              const input = document.getElementsByName(name);
              if (input.length > 0) {
                const lastInput = input[input.length - 1] as HTMLInputElement;
                lastInput.disabled = true;
              }
            });
            dispatch({
              type: "StoreMasterData",
              payload: {
                formkey: Form_Key,
                data: {
                  LR_Center: res?.data?.user[0]?.LR_Center_Data,
                },
              },
            });

            updateSingleField(formRef, "LR_Center", res?.data?.user?.[0]?.LR_Center_Data?.Center_Name || "");
            updateSingleField(formRef, "LR_No", res?.data?.user?.[0]?.LR_Center_Data?.lr_books?.Current_Number || "");
          } else {
            const inputNames = ["LR_Center"];

            inputNames.forEach((name) => {
              const input = document.getElementsByName(name);
              if (input.length > 0) {
                const lastInput = input[input.length - 1] as HTMLInputElement;
                lastInput.disabled = false;
              }
            });
          }
        });
      }
    }
  }, [userData?.userDetails[0]?._id, currentBranch, InputFields]);

  useEffect(() => {
    if (FormData?.Freight_Type && !allFieldsData?.Bill_Consignor) {
      setFormValue({ Freight_Type: FormData?.Freight_Type });
      dispatch({
        type: "StoreMasterData",
        payload: {
          formkey: Form_Key,
          data: {
            Bill_Consignor: {},
          },
        },
      });
      updateSingleField(formRef, "Bill_Consignor", "");
    }
  }, [FormData?.Freight_Type]);

  useEffect(() => {
    if (FormData?.LR_Center && !allFieldsData?.LR_No) {
      updateSingleField(
        formRef,
        "LR_No",
        FormDataFromRedux?.MasterData[Form_Key]?.LR_Center?.lr_books?.Current_Number || ""
      );
    } else if (!FormData?.LR_Center) {
      updateSingleField(formRef, "LR_No", "");
    }
  }, [FormData?.LR_Center]);

  useEffect(() => {
    if (FormDataFromRedux?.MasterData[Form_Key]?.LR_Center?.Editable) {
      const inputNames = ["LR_No"];

      inputNames.forEach((name) => {
        const input = document.getElementsByName(name);
        if (input.length > 0) {
          const lastInput = input[input.length - 1] as HTMLInputElement;
          lastInput.disabled = false;
        }
      });
    } else {
      const inputNames = ["LR_No"];

      inputNames.forEach((name) => {
        const input = document.getElementsByName(name);
        if (input.length > 0) {
          const lastInput = input[input.length - 1] as HTMLInputElement;
          lastInput.disabled = true;
        }
      });
    }
  }, [FormDataFromRedux?.MasterData[Form_Key]?.LR_Center]);

  useEffect(() => {
    console.log(FormData, "FormDataFormDataFormDataFormData")
  }, [FormData])

  useEffect(() => {
    if (myData?.material?.length > 0) {
      let newArr = myData?.material?.map((obj) => {
        let newObj = { ...obj };
        newObj.Invoice_Date = newObj.Invoice_Date ? IsoToDateWithoutTime(newObj.Invoice_Date) : "";
        newObj.Eway_Bill_Date = newObj.Eway_Bill_Date ? IsoToDateWithoutTime(newObj.Eway_Bill_Date) : "";
        newObj.Eway_Bill_Expiry_Date = newObj.Eway_Bill_Expiry_Date
          ? IsoToDateWithoutTime(newObj.Eway_Bill_Expiry_Date)
          : "";
        delete newObj.Invoice_Material_Data;
        delete newObj.Eway_Bill_Add;
        delete newObj.Invoice_Add;
        if (newObj?.__typename) {
          delete newObj?.__typename;
        }
        return newObj;
      });
      setTableData(newArr);
    } else {
      setTableData([]);
    }
  }, [myData?.material]);

  useEffect(() => {
    if (FormData?.Service_Type !== "") {
      const updatedLoadFields = Loadfilds.map((section) => {
        if (section.name === "Consignment_Note_Details") {
          return {
            ...section,
            fields: section.fields.map((field) => {
              if (field.name === "Vehicle_No") {
                return {
                  ...field,
                  isRequired: FormData?.Service_Type === "FTL" ? true : false,
                };
              }
              return field;
            }),
          };
        }
        return section;
      });
      setLoadFields(updatedLoadFields);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [FormData?.Service_Type]);

  // useEffect(() => {
  //   if (TypeOfPortal === "Add") {
  //     if (FormData?.Freight_Type === "Paid") {
  //       if (FormDataFromRedux?.MasterData?.[Form_Key]?.Consignor?.Bill_Account) {
  //         let bil_Account_Id = FormDataFromRedux?.MasterData?.[Form_Key]?.Consignor?.Bill_Account;
  //         if (bil_Account_Id) {
  //           GetBillAccountDataByID({ variables: { id: bil_Account_Id } }).then((res) => {
  //             if (res?.data?.Account) {
  //               dispatch({
  //                 type: "StoreMasterData",
  //                 payload: {
  //                   formkey: Form_Key,
  //                   data: {
  //                     Bill_Consignor: res?.data?.Account,
  //                   },
  //                 },
  //               });

  //               updateSingleField(formRef, "Bill_Consignor", res?.data?.Account?.Business_Name || "");
  //             }
  //           });
  //         }
  //       } else if (!FormDataFromRedux?.MasterData?.[Form_Key]?.Consignor?._id) {
  //         let accountData = FormDataFromRedux?.MasterData?.[Form_Key]?.Consignor;
  //         dispatch({
  //           type: "StoreMasterData",
  //           payload: {
  //             formkey: Form_Key,
  //             data: {
  //               Bill_Consignor: {
  //                 Business_Name: accountData?.Name,
  //                 Business_City: accountData?.City,
  //                 Business_Address: accountData?.Address_Line_1,
  //                 GST_Number: accountData?.GST_Number,
  //               },
  //             },
  //           },
  //         });
  //         updateSingleField(
  //           formRef,
  //           "Bill_Consignor",
  //           FormDataFromRedux?.MasterData?.[Form_Key]?.Consignor?.Name || ""
  //         );
  //         setConsignorAccountData((prev) => {
  //           return { ...prev, Add_Bill_Account: true, Is_Bill_Account_Created: true };
  //         });
  //         setConsigneeAccountData((prev) => {
  //           return { ...prev, Add_Bill_Account: false, Is_Bill_Account_Created: false };
  //         });
  //       } else if (FormDataFromRedux?.MasterData?.[Form_Key]?.Consignor?._id) {
  //         dispatch({
  //           type: "StoreMasterData",
  //           payload: {
  //             formkey: Form_Key,
  //             data: {
  //               Bill_Consignor: {},
  //             },
  //           },
  //         });
  //         updateSingleField(formRef, "Bill_Consignor", "");
  //       }
  //     } else if (FormData?.Freight_Type === "To Pay") {
  //       if (FormDataFromRedux?.MasterData?.[Form_Key]?.Consignee?.Bill_Account) {
  //         let bil_Account_Id = FormDataFromRedux?.MasterData?.[Form_Key]?.Consignee?.Bill_Account;
  //         if (bil_Account_Id) {
  //           GetBillAccountDataByID({ variables: { id: bil_Account_Id } }).then((res) => {
  //             console.log(res?.data?.Account, "res?.data?.Account");
  //             if (res?.data?.Account) {
  //               dispatch({
  //                 type: "StoreMasterData",
  //                 payload: {
  //                   formkey: Form_Key,
  //                   data: {
  //                     Bill_Consignor: res?.data?.Account,
  //                   },
  //                 },
  //               });

  //               updateSingleField(formRef, "Bill_Consignor", res?.data?.Account?.Business_Name || "");
  //             }
  //           });
  //         }
  //       } else if (!FormDataFromRedux?.MasterData?.[Form_Key]?.Consignee?._id) {
  //         let accountData = FormDataFromRedux?.MasterData?.[Form_Key]?.Consignee;
  //         dispatch({
  //           type: "StoreMasterData",
  //           payload: {
  //             formkey: Form_Key,
  //             data: {
  //               Bill_Consignor: {
  //                 Business_Name: accountData?.Name,
  //                 Business_City: accountData?.City,
  //                 Business_Address: accountData?.Address_Line_1,
  //                 GST_Number: accountData?.GST_Number,
  //               },
  //             },
  //           },
  //         });

  //         updateSingleField(
  //           formRef,
  //           "Bill_Consignor",
  //           FormDataFromRedux?.MasterData?.[Form_Key]?.Consignee?.Name || ""
  //         );
  //         setConsignorAccountData((prev) => {
  //           return { ...prev, Add_Bill_Account: false, Is_Bill_Account_Created: false };
  //         });
  //         setConsigneeAccountData((prev) => {
  //           return { ...prev, Add_Bill_Account: true, Is_Bill_Account_Created: true };
  //         });
  //       } else if (FormDataFromRedux?.MasterData?.[Form_Key]?.Consignee?._id) {
  //         dispatch({
  //           type: "StoreMasterData",
  //           payload: {
  //             formkey: Form_Key,
  //             data: {
  //               Bill_Consignor: {},
  //             },
  //           },
  //         });

  //         updateSingleField(formRef, "Bill_Consignor", "");
  //       }
  //     }
  //   }
  // }, [
  //   FormData?.Freight_Type,
  //   FormDataFromRedux?.MasterData?.[Form_Key]?.Consignee,
  //   FormDataFromRedux?.MasterData?.[Form_Key]?.Consignor,
  // ]);

  useEffect(() => {
    let totalBoxes = 0;
    let totalWeight = 0;
    let totalQuantity = 0;
    let totalFreightAmount = 0;

    if (itemsData) {
      itemsData.forEach((materialItem: any) => {
        totalBoxes += Number(materialItem.No_Of_Boxes);
      });
      itemsData.forEach((materialItem: any) => {
        totalWeight += Number(materialItem.Charge_Weight);
      });
      itemsData.forEach((materialItem: any) => {
        totalQuantity += Number(materialItem.Total_Quantity);
      });
      itemsData.forEach((materialItem: any) => {
        totalFreightAmount += Number(materialItem.Freight_Amount);
      });
    }
    console.log(totalWeight, "totalWeighttotalWeight")
    updateSingleField(formRef, "Total_Weight", totalWeight);
    updateSingleField(formRef, "Total_Article", totalBoxes);
    updateSingleField(formRef, "Total_Quantity", totalQuantity);
    updateSingleField(formRef, "Freight_Amount", totalFreightAmount);
    setTotalArticle(totalBoxes)
    setTotalWeight(totalWeight);
    setTotalQuantity(totalQuantity)
    // setTotalFreightAmount(totalFreightAmount);
  }, [itemsData]);

  const extractGSTType = (input) => {
    const match = input?.match(/^(GST|IGST)/);
    return match ? match[0] : "";
  };

  useEffect(() => {
    if (FormDataFromRedux?.MasterData[Form_Key]?.Service_Type && FormData?.GSTPaidBy) {
      let hsnPercentage = FormDataFromRedux?.MasterData[Form_Key]?.Service_Type?.Tax_Group_Data;

      let Party = FormDataFromRedux?.MasterData[Form_Key]?.Bill_Consignor;
      console.log(Party, "PartyParty");
      let Tax_Type = extractGSTType(hsnPercentage?.Tax_Group_Name);
      let Percentage = hsnPercentage?.Tax_Rate?.Tax_Percentage;

      console.log(Tax_Type, Percentage, " Tax_TypPercentage");
      setGSTPercentage(Percentage);
      updateSingleField(formRef, "TaxType", Tax_Type);
    }
  }, [FormDataFromRedux?.MasterData[Form_Key]?.Service_Type, FormData?.GSTPaidBy]);

  const getDefaultValues = async () => {
    // console.log("call2");
    const { data } = await getDataByKey({
      variables: {
        Form_Key,
      },
    });
    let obj = { ...data?.User_Preferences_By_Form_Key?.configurationData };

    dispatch({
      type: "StoreMasterData",
      payload: {
        formkey: "Preference",
        data: {
          Default_Service_Type: obj?.Default_Service_Type,

          Default_Assign_Pickup: obj?.Default_Assign_Pickup,
        },
      },
    });
    obj.Default_Service_Type = obj?.Default_Service_Type?.Service_Type_Name;

    obj.Default_Assign_Pickup = obj?.Default_Assign_Pickup?.Search_Value;

    setFormdata((prev) => ({
      ...prev,
      ...obj,
    }));

    return data?.User_Preferences_By_Form_Key?.configurationData;
  };

  let updateDefaultdata = () => {
    getDefaultValues()
      .then((defaultData) => {
        // console.log(defaultData, "defaultData");
        dispatch({
          type: "StoreMasterData",
          payload: {
            formkey: Form_Key,
            data: {
              Service_Type: defaultData?.Default_Service_Type,
              LR_Center: defaultData?.Default_LR_Center,
              Assign_Pickup: defaultData?.Default_Assign_Pickup,
            },
          },
        });
        updateValueForm(formRef, {
          Date: GetTodaysDateINdmy() || "",
          FOV: 0,
          Freight_Type: defaultData?.Default_Freight_Type,
          Delivery: defaultData?.Default_Delivery,
          From_City: defaultData?.Default_From_City,
          To_City: defaultData?.Default_To_City,
          Service_Type: defaultData?.Default_Service_Type?.Service_Type_Name,
          LR_Center: defaultData?.Default_LR_Center?.Center_Name,
          Assign_Pickup: defaultData?.Default_Assign_Pickup?.Search_Value,
        });
      })
      .catch((err) => {
        updateValueForm(formRef, {
          Date: GetTodaysDateINdmy() || "",
          FOV: 0,
        });
      });
  };

  useEffect(() => {
    if (InputFields.length) {
      if (TypeOfPortal === "Edit" || TypeOfPortal === "View") {
        getDataById({
          variables: {
            id: openByCard ? openByCardId : selectedRow,
          },
        }).then((res) => {
          let data = { ...res?.data?.getLoadReceiptById[0] };

          delete data?.__typeName;
          // delete data?.LR_Invoice_Data;
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: Form_Key,
              data: {
                Consignor: data?.Consignor_Data,
                Consignee: data?.Consignee_Data,
                Bill_Consignor: data?.Bill_Consignor_Data,
                Assign_Pickup: data.Assign_Pickup_Data,
                Consignor_Person: data.Consignor_Person_Data,
                Consignee_Person: data.Consignee_Person_Data,
                Bill_Consignor_Person: data.Bill_Consignor_Person_Data,
                Service_Type: data?.Service_Type_Data,
                LR_Center: data?.LR_Center_Data,
                Key_Account_Manager: data?.Key_Account_Manager_Data,
                Branch_Code: data?.Branch_Code_Data,
              },
            },
          });
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: "Preference",
              data: {
                Default_Service_Type: data?.Default_Service_Type,
                Default_Assign_Pickup: data?.Default_Assign_Pickup,
              },
            },
          });
          data.Default_Service_Type = data?.Default_Service_Type?.Service_Type_Name;
          data.Default_Assign_Pickup = data?.Default_Assign_Pickup?.Name;
          data.Assign_Pickup = data?.Assign_Pickup_Data?.Name;
          data.Consignor = data?.Consignor_Data?.Search_Value;
          data.Consignee = data?.Consignee_Data?.Search_Value;
          data.Bill_Consignor = data?.Bill_Consignor_Data?.Search_Value;
          data.Consignor_Person = data?.Consignor_Person_Data?.Name;
          data.Consignee_Person = data?.Consignee_Person_Data?.Name;
          data.Key_Account_Manager = data?.Key_Account_Manager_Data?.Full_Name;
          data.Bill_Consignor_Person = data?.Bill_Consignor_Person_Data?.Name;

          // data.material = res?.data?.getLoadReceiptById[0]?.LR_Invoice_Data;
          data.Service_Type = data?.Service_Type_Data?.Service_Type_Name;
          data.LR_Center = data?.LR_Center_Data?.Center_Name;
          data.Date = IsoToDateWithoutTime(data?.Date);
          if (data.Freight_On === "Per Article") {
            setSendValue(data?.Total_Number_Of_Boxes);
          } else if (data.Freight_On === "Quantity") {
            let totalQuant = 0;
            data.LR_Invoice_Data.forEach((materialItem: any) => {
              totalQuant += Number(materialItem.Total_Quantity);
            });
            setSendValue(totalQuant);
          }
          let invoiceD = data?.LR_Invoice_Data?.map((e) => ({
            ...e,
            Invoice_Date: e?.Invoice_Date ? IsoToDateWithoutTime(e?.Invoice_Date) : "",
            Eway_Bill_Date: e?.Eway_Bill_Date ? IsoToDateWithoutTime(e?.Eway_Bill_Date) : "",
            Eway_Bill_Expiry_Date: e?.Eway_Bill_Expiry_Date ? IsoToDateWithoutTime(e?.Eway_Bill_Expiry_Date) : "",
          }));
          setCustomerNotesdata(data?.Customer_Note);
          setGSTPercentage(data?.GSTPercentage);
          setNotesdata(data?.Notes);
          setFovPercentage(data?.FovPercentage);
          setInvoiceData(invoiceD);
          setItemsData(data?.Invoice_Material_Data);
          setAllFieldsData(data);

          updateValueForm(formRef, data);
        });
      } else if (TypeOfPortal == "Copy") {
        getDataByIdForCopy({
          variables: {
            id: selectedRow,
          },
        }).then((res) => {
          let data = { ...res?.data?.getLoadReceiptById[0] };
          delete data?.__typeName;
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: Form_Key,
              data: {
                Consignor: data?.Consignor_Data,
                Consignee: data?.Consignee_Data,
                Bill_Consignor: data?.Bill_Consignor_Data,
                Assign_Pickup: data.Assign_Pickup_Data,
                Consignor_Person: data.Consignor_Person_Data,
                Consignee_Person: data.Consignee_Person_Data,
                Bill_Consignor_Person: data.Bill_Consignor_Person_Data,
                Service_Type: data?.Service_Type_Data,
                LR_Center: data?.LR_Center_Data,
                Key_Account_Manager: data?.Key_Account_Manager_Data,
                Branch_Code: data?.Branch_Code_Data,
              },
            },
          });
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: "Preference",
              data: {
                Default_Service_Type: data?.Default_Service_Type,
                Default_Assign_Pickup: data?.Default_Assign_Pickup,
              },
            },
          });
          data.Default_Service_Type = data?.Default_Service_Type?.Service_Type_Name;
          data.Default_Assign_Pickup = data?.Default_Assign_Pickup?.Name;
          data.Assign_Pickup = data?.Assign_Pickup_Data?.Name;
          data.Consignor = data?.Consignor_Data?.Search_Value;
          data.Consignee = data?.Consignee_Data?.Search_Value;
          data.Bill_Consignor = data?.Bill_Consignor_Data?.Search_Value;
          data.Consignor_Person = data?.Consignor_Person_Data?.Name;
          data.Consignee_Person = data?.Consignee_Person_Data?.Name;
          data.Bill_Consignor_Person = data?.Bill_Consignor_Person_Data?.Name;
          data.Key_Account_Manager = data?.Key_Account_Manager_Data?.Full_Name;
          data.Service_Type = data?.Service_Type_Data?.Service_Type_Name;
          data.LR_Center = data?.LR_Center_Data?.Center_Name;
          data.Date = GetTodaysDateINdmy() || "";
          setItemsData(data?.Invoice_Material_Data);
          setAllFieldsData(data);
          updateValueForm(formRef, data);
        });
      } else if (TypeOfPortal == "Add") {
        updateDefaultdata();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [TypeOfPortal, InputFields]);

  let FetchEwbData = () => {
    // 591008944271
    const ewayBillPattern = /^\d{12}$/;
    if (ewayBillPattern.test(ewbNo)) {
      getewbDetailsByNo({ variables: { eWayBillNo: ewbNo } })
        .then((res) => {
          let ewbData = res?.data?.getEwayBillDetailsByEwayBillNo;

          if (ewbData && ewbNos.length == 0) {
            setEwbNos((prev) => {
              return [...prev, ewbNo];
            });
            updateSingleField(formRef, "From_City", ewbData?.fromPlace || "");
            updateSingleField(formRef, "To_City", ewbData?.toPlace || "");
            // getERPBookDetails({
            //   variables: {
            //     address: [{ address: ewbData?.fromAddr1 }, { address: ewbData?.toAddr1 }],
            //   },
            // })
            //   .then((response) => {
            //     console.log(response, "ewat");
            //     let bookData = response?.data?.ERPAddressBookByGSTIN;
            //     console.log(bookData, "bookDatabookData")
            //     if (bookData?.Consignor) {
            //       dispatch({
            //         type: "StoreMasterData",
            //         payload: {
            //           formkey: Form_Key,
            //           data: {
            //             Consignor: bookData?.Consignor,
            //           },
            //         },
            //       });
            //       console.log(bookData?.Consignor, "Consignor1");
            //       updateSingleField(formRef, "Consignor", bookData?.Consignor?.Search_Value || "");
            //     } else {
            //       dispatch({
            //         type: "StoreMasterData",
            //         payload: {
            //           formkey: Form_Key,
            //           data: {
            //             Consignor: {
            //               Business_Name: ewbData?.fromTrdName,
            //               GST_Number: ewbData?.fromGstin,
            //               Business_Address: ewbData?.fromAddr1,
            //               Business_City: ewbData?.fromPlace,
            //               Search_Value: ewbData?.fromTrdName,
            //             },
            //           },
            //         },
            //       });
            //       updateSingleField(formRef, "Consignor", ewbData?.fromTrdName || "");
            //       setConsignorAccountData({
            //         Business_Name: ewbData?.fromTrdName,
            //         GST_Number: ewbData?.fromGstin,
            //         Business_Address: ewbData?.fromAddr1,
            //         Business_City: ewbData?.fromPlace,
            //       });
            //     }

            //     if (bookData?.Consignee) {
            //       dispatch({
            //         type: "StoreMasterData",
            //         payload: {
            //           formkey: Form_Key,
            //           data: {
            //             Consignee: bookData?.Consignee,
            //           },
            //         },
            //       });
            //       console.log(bookData?.Consignee, "Consignor2");
            //       updateSingleField(formRef, "Consignee", bookData?.Consignee?.Search_Value || "");
            //     } else {
            //       dispatch({
            //         type: "StoreMasterData",
            //         payload: {
            //           formkey: Form_Key,
            //           data: {
            //             Consignee: {
            //               Business_Name: ewbData?.toTrdName,
            //               GST_Number: ewbData?.toGstin,
            //               Business_Address: ewbData?.toAddr1,
            //               Business_City: ewbData?.toPlace,
            //               Search_Value: ewbData?.toTrdName,
            //             },
            //           },
            //         },
            //       });
            //       updateSingleField(formRef, "Consignee", ewbData?.toTrdName || "");
            //       setConsigneeAccountData({
            //         Business_Name: ewbData?.toTrdName,
            //         GST_Number: ewbData?.toGstin,
            //         Business_Address: ewbData?.toAddr1,
            //         Business_City: ewbData?.toPlace,
            //       });
            //     }
            //   })
            //   .catch((err) => console.log(err));
          }
          if (ewbData) {
            setInvoiceData((prev) => {
              return [
                ...prev,
                {
                  Invoice_Date: ewbData?.docDate ? ewbData?.docDate : "",
                  Invoice_Number: ewbData?.docNo ? String(ewbData?.docNo) : "",
                  Invoice_Value: ewbData?.totInvValue ? String(ewbData?.totInvValue) : "",
                  Eway_Bill_Number: ewbData?.ewbNo ? String(ewbData?.ewbNo) : "",
                  Eway_Bill_Date: ewbData?.ewayBillDate ? ewbData?.ewayBillDate.split(" ")[0] : "",
                  Eway_Bill_Expiry_Date: ewbData?.validUpto ? ewbData?.validUpto.split(" ")[0] : "",
                  ASN_No: "",
                  Invoice_Add: "",
                  Eway_Bill_Add: "",
                },
              ];
            });
            setEwbNo("");
          } else {
            ErrorToast("Unable To Fetch EWB Data");
          }
        })
        .catch((err) => {
          console.log(err);
          ErrorToast("Unable To Fetch EWB Data");
        });
    } else {
      ErrorToast("Insert Valid Ewb Number");
    }
  };

  let handleAddInvoiceData = (invoice, items) => {
    console.log(invoice, items);
    setInvoiceData(invoice);
    setItemsData(items);
  };

  let handleFoucs = (id) => {
    const input = document.getElementById(id);
    if (input) {
      input.focus();
    }
  };

  const handleDeleteMaterial = (index) => {
    setMyData((prevState) => {
      const newMaterial = [...prevState.material];
      newMaterial.splice(index, 1);
      return { ...prevState, material: newMaterial };
    });
  };

  useEffect(() => {
    const value = FormDataFromRedux?.MasterData[Form_Key]?.Branch_Code;
    if (TypeOfPortal === "Add" && value && currentBranch && currentBranch?._id !== value?._id) {
      setInvoiceData([]);
      setItemsData([]);
      setModifiedItemData([]);
      ClearSpecificForm(dispatch, Form_Key);
      ClearFields(formRef);
    }
    setCurrentBranch(value);
  }, [FormDataFromRedux?.MasterData[Form_Key]?.Branch_Code]);

  useEffect(() => {
    if (invoiceData?.length > 0 && FovPercentage) {
      const totalInvoiceValue = invoiceData.reduce((sum, invoice) => sum + Number(invoice.Invoice_Value), 0);
      let value = (totalInvoiceValue * FovPercentage) / 100;
      updateSingleField(formRef, "FOV", value.toFixed(2));
    }
  }, [invoiceData, FovPercentage]);

  const replaceObjectAtIndex = (newObj, idx) => {
    const newArr = myData.material.map((item, index) => {
      if (index === idx) {
        return newObj;
      }
      return item;
    });

    setMyData((prevState: any) => {
      return { ...prevState, material: newArr };
    });
  };

  const HandleSettingClick = () => {
    setOpenSetting(true);
  };

  function isValidISODate(str) {
    const date = new Date(str);
    return !isNaN(date.getTime());
  }

  const handleEdit = (i) => {
    setEditIndex((prev) => String(i));
    setMeterial(true);
  };

  const HanldeChangeonForm = (values) => {
    setFormdata(prev => {
      const next = { ...prev, ...values };
      if (!isFirstLoad) {
        setInitialData(next)
      }
      return next
    })
  };


  const submit = async (close) => {
    let CNmasterData = FormDataFromRedux?.MasterData?.[Form_Key];
    let obj = {
      ...FormData,
      LR_Center: CNmasterData?.LR_Center?._id,
      Service_Type: CNmasterData?.Service_Type?._id,
      Assign_Pickup: CNmasterData?.Assign_Pickup?._id,
      Date: FormData?.Date ? convertToISO(FormData?.Date) : null,
      LR_No: FormData?.LR_No ? String(FormData?.LR_No) : null,
    };

    obj.Consignor = CNmasterData?.Consignor?._id;
    obj.Consignee = CNmasterData?.Consignee?._id;
    obj.Bill_Consignor = CNmasterData?.Bill_Consignor?._id;
    obj.Key_Account_Manager = CNmasterData?.Key_Account_Manager?._id;
    // if (CNmasterData?.Consignor?._id) {
    //   obj.Consignor = CNmasterData?.Consignor?._id;
    // } else {
    //   await CreatingCustomerAccount({ createInput: consignorAccountData }).then((res) => {
    //     let CSId = res?.data?.createAccount?._id
    //     obj.Consignor = CSId;
    //   }).catch((err) => {
    //     ErrorToast(err.message)
    //   })
    // }
    // if (CNmasterData?.Consignee?._id) {
    //   obj.Consignee = CNmasterData?.Consignee?._id;
    // } else {
    //   await CreatingCustomerAccount({ createInput: consigneeAccountData }).then((res) => {
    //     let CSId = res?.data?.createAccount?._id
    //     obj.Consignor = CSId;
    //   }).catch((err) => {
    //     ErrorToast(err.message)
    //   })
    // }
    // if (CNmasterData?.Bill_Consignor?._id) {
    //   obj.Bill_Consignor = CNmasterData?.Bill_Consignor?._id;
    // } else if (obj?.Freight_Type == "Paid") {
    //   obj.Bill_Consignor = obj.Consignor
    // } else if (obj?.Freight_Type == "To Pay") {
    //   obj.Bill_Consignor = obj.Consignee
    // }

    obj.LR_Book_Id = CNmasterData?.LR_Center?.lr_books?._id;
    obj["Notes"] = notesdata;
    obj["Consignor_GST_No"] = CNmasterData?.Consignor?.GST_Number ? CNmasterData?.Consignor?.GST_Number : "";
    obj["Consignee_GST_No"] = CNmasterData?.Consignee?.GST_Number ? CNmasterData?.Consignee?.GST_Number : "";
    obj["Bill_GST_No"] = CNmasterData?.Bill_Consignor?.GST_Number ? CNmasterData.Bill_Consignor.GST_Number : "";
    obj["Consignor_City"] = CNmasterData?.Consignor?.Business_City ? CNmasterData?.Consignor?.Business_City : "";
    obj["Consignee_City"] = CNmasterData?.Consignee?.Business_City ? CNmasterData?.Consignee?.Business_City : "";
    obj["Bill_City"] = CNmasterData?.Bill_Consignor?.Business_City ? CNmasterData.Bill_Consignor.Business_City : "";
    obj["Consignor_Address"] = CNmasterData?.Consignor?.Business_Address
      ? CNmasterData?.Consignor?.Business_Address
      : "";
    obj["Consignee_Address"] = CNmasterData?.Consignee?.Business_Address
      ? CNmasterData?.Consignee?.Business_Address
      : "";
    obj["Bill_Consignor_Address"] = CNmasterData?.Bill_Consignor?.Business_Address
      ? CNmasterData.Bill_Consignor.Business_Address
      : "";

    let acutalWeight = 0;
    let volumetricWeight = 0;

    let materialData = invoiceData.map((materialItem) => {
      let newObj = { ...materialItem };
      newObj.ASN_No = String(newObj?.ASN_No);
      newObj.Eway_Bill_Number = String(newObj?.Eway_Bill_Number);
      if (newObj?.Invoice_Date && !isValidISODate(newObj?.Invoice_Date)) {
        newObj.Invoice_Date = convertToISO(newObj?.Invoice_Date);
      }
      if (newObj?.Eway_Bill_Date && !isValidISODate(newObj?.Eway_Bill_Date)) {
        newObj.Eway_Bill_Date = convertToISO(newObj?.Eway_Bill_Date);
      }
      if (newObj?.Eway_Bill_Expiry_Date && !isValidISODate(newObj?.Eway_Bill_Expiry_Date)) {
        newObj.Eway_Bill_Expiry_Date = convertToISO(newObj?.Eway_Bill_Expiry_Date);
      }

      if (newObj?.__typename) {
        delete newObj.__typename;
      }
      if (TypeOfPortal !== "Edit") {
        delete newObj?._id;
      }

      return newObj;
    });

    let updateItemData = itemsData.map((item) => {
      let clonedItem = { ...item };
      if (TypeOfPortal !== "Edit") {
        delete clonedItem._id;
      }
      if (clonedItem?.__typename) {
        delete clonedItem.__typename;
      }
      if (clonedItem.Part_Name_Data) {
        clonedItem.Part_Name = clonedItem.Part_Name_Data?._id;

      }
      if (clonedItem.Packaging_Data) {
        clonedItem.Packaging = clonedItem.Packaging_Data?._id;
      }
      // if (TypeOfPortal === "Edit") {
      delete clonedItem.Part_Name_Data;
      delete clonedItem.Packaging_Data;
      // }
      acutalWeight += Number(clonedItem.Actual_Weight);
      volumetricWeight += Number(clonedItem.Volumetric_Weight);
      return clonedItem;
    });
    console.log(acutalWeight);
    obj.Total_Volumetric_Weight = volumetricWeight;
    obj.Total_Actual_Weight = acutalWeight;
    obj.Total_Weight = totalWeight;
    obj["LR_Invoice_Data"] = materialData;
    obj["Invoice_Material_Data"] = updateItemData;

    obj.Consignor_Person = CNmasterData?.Consignor_Person?._id;
    obj.Consignee_Person = CNmasterData?.Consignee_Person?._id;
    obj.Bill_Consignor_Person = CNmasterData?.Bill_Consignor_Person?._id;
    obj.Default_Service_Type = FormDataFromRedux?.MasterData?.Preference?.Default_Service_Type?._id;
    obj.Default_Assign_Pickup = FormDataFromRedux?.MasterData?.Preference?.Default_Assign_Pickup?._id;
    obj.From_City_StateCode = CNmasterData?.From_City?.State_Code
    obj.FovPercentage = FovPercentage;
    obj.Customer_Note = customerNotesdata;
    obj.Total_Number_Of_Boxes = totalArticle;
    delete obj.Invoice_Add;
    delete obj.Eway_Bill_Add;
    if (FormData?.GSTPaidBy === "Transporter") {
      obj.Total_Amount = Math.round(
        Number(FormData?.Total) + Number(((Number(FormData?.Total) * Number(GSTPercentage)) / 100).toFixed(1))
      );
      obj.GSTPercentage = Number(GSTPercentage);
    }

    if (TypeOfPortal === "Add" || TypeOfPortal === "Copy") {
      console.log(obj, "objobjobj");
      await createLoadReceipt({
        variables: {
          LoadReceiptInput: obj,
        },
      })
        .then((res) => {
          console.log(res?.data?.createLoadReceiptMaster);
          SuccessToast("Consignment Note(LR) Created Sucessfully");
          dispatch({ type: "Refetch", payload: true });
          if (close == "close") {
            Closeformfunction();
          } else if (close == "Print") {
            setCNid(res?.data?.createLoadReceiptMaster?._id);
            setNotesdata("");
            setCustomerNotesdata("");
            ClearSpecificForm(dispatch, Form_Key);
            setSendValue(0);
            setFovPercentage(0);
            setInvoiceData([]);
            setItemsData([]);
            setModifiedItemData([]);
            setMyData({ material: [] });
            handleFormReset(formRef);
            console.log(CNid);
            setShowPrintPage(true);
          } else {
            setNotesdata("");
            setCustomerNotesdata("");
            ClearSpecificForm(dispatch, Form_Key);
            setSendValue(0);
            setFovPercentage(0);
            setInvoiceData([]);
            setItemsData([]);
            setModifiedItemData([]);
            setMyData({ material: [] });
            handleFormReset(formRef);
            updateDefaultdata();
          }
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    }
    if (TypeOfPortal === "Edit") {
      await editLoadReceipt({
        variables: {
          id: openByCard ? openByCardId : selectedRow,
          LoadReceiptInput: obj,
        },
      })
        .then((res) => {
          dispatch({ type: "Refetch", payload: true });
          SuccessToast("Consignment Note(LR) Edited Sucessfully");
          if (close == "Print") {
            setCNid(selectedRow);
            setShowPrintPage(true);
          } else {
            Closeformfunction();
          }
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    }
    if (TypeOfPortal == "Delete") {
      await deleteLoadReceipt({
        variables: {
          idsToDelete: selectedRows,
        },
      })
        .then((res) => {
          Closeformfunction();
          SuccessToast("Consignment Note(LR) Deleted Sucessfully");
          dispatch({ type: "Refetch", payload: true });
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    }
  };

  let handleFreightOnChange = (type: string) => {
    if (type === "Per Article") {
      setSendValue(totalArticle);
    } else if (type === "Quantity") {
      setSendValue(totalQuantity);
    }
  };

  let handleLockRecords = async () => {
    await lockLoadReceipt({
      variables: {
        idsToUpdate: selectedRows,
        Is_Lock: TypeOfPortal == "Lock" ? true : false
      },
    })
      .then((res) => {
        dispatch({ type: "Refetch", payload: true });
        SuccessToast(`Consignment Note(LR) ${TypeOfPortal} Successfully`);
        Closeformfunction();
      })
      .catch((err) => {
        ErrorToast(err.message);
      });
  }

  const Closeformfunction = () => {
    setMyData({ material: [] });
    setNotesdata("");
    handleFormReset(formRef);
    setInvoiceData([]);
    setItemsData([]);
    setModifiedItemData([]);
    setFovPercentage(0);
    ClearSpecificForm(dispatch, Form_Key);
    settoggle(false);
    ParentPortalCloseFunction();
  };

  if (TypeOfPortal === "Audit Load" || modifiedTypeOfPortal === "Audit Consignment Note") {
    submit();
    return <></>;
  }

  if (TypeOfPortal === "Delete") {
    return (
      <Reactportal open={toggle} onClose={() => settoggle(false)} TypeOfPortal={"Confirm"}>
        <div className="warning">
          <RiErrorWarningFill className="warningIcon" />
          <p className="warningMsg">Are You Sure You Want to Delete this Record?</p>
        </div>

        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={submit}
          submitType={"Confirm Delete"}
          handleformclose={() => {
            settoggle(!toggle);
          }}
          loadingState={deleteLoading}
        />
      </Reactportal>
    );
  }

  if (TypeOfPortal === "Lock" || TypeOfPortal === "Unlock") {
    return (
      <>
        <Confirm
          submitType={`Confirm ${TypeOfPortal}`}
          submit={handleLockRecords}
          settoggle={settoggle}
          toggle={toggle}
          loadingState={LockLoading}
          message={`Are You Sure You Want to ${TypeOfPortal} this Record?`}
        />
      </>
    );
  }


  return (
    <>
      <Reactportal
        open={toggle}
        onClose={Closeformfunction}
        TypeOfPortal={modifiedTypeOfPortal}
        ShowBranchInput={true}
        Form_Key={Form_Key}
        id={allFieldsData?.Unique_Id ? allFieldsData?.Unique_Id : ""}
        TypeOfId={allFieldsData?.Unique_Id ? allFieldsData?.Unique_Id : ""}
        idTitle="Booking ID"
        AdditionalContent={() => {
          return (
            <span onClick={HandleSettingClick} className="settingIcon">
              {" "}
              <IoSettingsOutline className="settingIcon" />
            </span>
          );
        }}
      >
        {LoadingState && <div className="loader-line-div" />}
        <div className="loadReceiptmaindiv">
          {/* Section-1 */}
          {/* <div className="ewayBillmaindiv">
            <input
              type="number"
              className="ewayInput no-spinners"
              value={ewbNo}
              onChange={(e) => setEwbNo(e.target.value)}
            />
            {getewbDetailsByNoLoader ? (
              <Button type="" text={<Spinner />} action="" disabled={true} children="" name="" />
            ) : (
              <Button
                action={() => FetchEwbData()}
                text={"Fetch EWB Data"}
                name="ewaybtn"
                type={""}
                children={""}
                disabled={""}
              />
            )}
          </div> */}
          <div className="horizontalcontainer">
            {InputFields &&
              InputFields.map((e) => {
                return (
                  <div key={e.id} className="">
                    <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                    <div className="horizantalSection insidecontainer">
                      <FormInputSectionComponent
                        inputfields={e.fields}
                        Type={e.name}
                        onhandleFormikChange={HanldeChangeonForm}
                        validation_Schema={e?.Valid_schema}
                        onErrorsChange={(newErrors) => handleErrorsChange(newErrors)}
                        formkey={Form_Key}
                        formRef={formRef}
                        setFirstLoad={setFirstLoad}
                      />
                    </div>
                  </div>
                );
              })}
          </div>
          {/* {section-2} */}
          <div className="AccountDetailsSectionBox">
            {UserDetailInputFields?.map((user) => {
              return (
                <MainUserDetails
                  inputfields={user.fields}
                  handleErrorsChange={handleErrorsChange}
                  fielddata={FormData}
                  formkey={Form_Key}
                  Type={user.name}
                  formRef={formRef}
                  TypeOfPortal={TypeOfPortal}
                  onhandleFormikChange={HanldeChangeonForm}
                  allFieldsData={allFieldsData}
                  setFirstLoad={setFirstLoad}
                />
              );
            })}
          </div>
          {/* {section-3} */}

          <div className="DataTableSection">
            <AddMeterialTable
              data={invoiceData}
              Form_Key={Form_Key}
            // handleDeleteMaterial={(i) => handleDeleteMaterial(i)}
            // handleEditMaterial={(i) => handleEdit(i)}
            />
          </div>
          <div className="MeterialButton">
            <Button
              action={() => setMeterial(true)}
              text="ADD"
              name="AddMeterial"
              type={""}
              children={""}
              disabled={""}
            />
          </div>
          {Meterial ? (
            <>
              <AddMaterialEwayBill
                SetMeterial={() => {
                  setMeterial(false);
                  setEditIndex("");
                }}
                handleAddInvoiceData={handleAddInvoiceData}
                show={Meterial}
                config={{ AddMaterial, AddMeterialItems, AddMeterialDocsUpload }}
                Data={{ invoiceData, itemsData }}
                Form_Key={Form_Key}
                handleFoucs={handleFoucs}
                priceListData={priceListData}
                TypeOfPortal={TypeOfPortal}
              />
            </>
          ) : null}
          {/* Section-4 */}
          <div className="ReceiptNoteImageDetails">
            <div className="subNoteImage">
              <div>
                <div>
                  <p className="NoteLable1">Note</p>
                </div>
                <div className="moredetailsection1">
                  <textarea
                    id="notefocus"
                    name="note"
                    value={notesdata}
                    onChange={(e) => setNotesdata(e.target.value)}
                  ></textarea>
                </div>
              </div>
              <div>
                <div>
                  <p className="NoteLable1">Customer Note</p>
                </div>
                <div className="moredetailsection1 customerNote">
                  <textarea
                    name="note"
                    value={customerNotesdata}
                    onChange={(e) => setCustomerNotesdata(e.target.value)}
                  ></textarea>
                </div>
              </div>
            </div>

            <div className="subNoteImage">
              <div className="">
                {DocumentsFields?.length > 0 &&
                  DocumentsFields.map((e) => {
                    return (
                      <div key={e.id} className="">
                        <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                        <div className="horizantalSection insidecontainer">
                          <FormInputSectionComponent
                            inputfields={e.fields}
                            Type={e.name}
                            onhandleFormikChange={HanldeChangeonForm}
                            validation_Schema={e?.Valid_schema}
                            onErrorsChange={(newErrors) => handleErrorsChange(newErrors)}
                            formkey={Form_Key}
                            TypeOfPortal={TypeOfPortal}
                            formRef={formRef}
                          />
                        </div>
                      </div>
                    );
                  })
                }
              </div>
            </div>

            <div className="subNoteImage">
              <div>
                <p className="NoteLable3">Fright Charges</p>
              </div>
              <div className="Freight">
                {FreightFields &&
                  FreightFields.map((e: any, i) => {
                    return (
                      <LRPickupUpdationFreightChargesForm
                        inputfields={e.fields}
                        Type={e.name}
                        totalFreightAmount={totalFreightAmount}
                        handleFreightOnChange={handleFreightOnChange}
                        TypeOfPortal={TypeOfPortal}
                        formkey={Form_Key}
                        FormData={FormData}
                        formRef={formRef}
                        onhandleFormikChange={HanldeChangeonForm}
                        handleErrorsChange={() => handleErrorsChange()}
                        FovPercentage={FovPercentage}
                        setFovPercentage={setFovPercentage}
                        GSTPercentage={GSTPercentage}
                      />
                    );
                  })}
              </div>
            </div>
          </div>
          {showPrintPage && (
            <InvoiceFormat
              show={showPrintPage}
              TableKey={Form_Key}
              TypeOfPortal={"Print"}
              ParentPortalCloseFunction={() => setShowPrintPage(false)}
              id={CNid}
              triggerPrint={true}
              defaultLayout={defaultLayout}
            />
          )}
        </div>
        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          // showPrintButton={true}
          Form_key={Form_Key}
          TypeOfPortal={TypeOfPortal}
          handlePagePrint={() => {
            Validate_handleSubmit(submit, "Print");
          }}
          submitform={() => {
            Validate_handleSubmit(submit, "");
          }}
          TypeOfPortal={TypeOfPortal}
          submitType={submitType}
          SaveAndClose={() => {
            Validate_handleSubmit(submit, "close");
          }}
          handleformclose={(e) => {
            Closeformfunction();
          }}
          handleKeydownFun={(e) => {
            if (e.key == "Tab") {
              e.preventDefault();
              handleInitFocus();
            }
          }}
          loadingState={CreateLoading || EditLoading || GetLoading ? true : false}
        />
      </Reactportal>
      {openSetting && (
        <FormConfiguration
          show={openSetting}
          ParentClosingFunction={setOpenSetting}
          config={ConsignmentNoteConfiguration}
          HanldeChangeonForm={HanldeChangeonForm}
          formRef={formRef}
          setFirstLoad={setFirstLoad}
          allFieldsData={allFieldsData}
          getFormSectionAndFields={getFormSectionAndFields}
          formKey={Form_Key}
          forFormValues={FormData}
          preference={true}
          ToGetDefaultValues={() => {
            if (TypeOfPortal == "Add") {
              updateDefaultdata();
            }
          }}
        />
      )}
    </>
  );
};

export default AddConsignmentNote;
